import React, { Component } from 'react';
import StandardTextsComponent from '../../../../../../components/StandardTexts';

/**
 * Standard texts screen, for showing standard texts list.
 *
 * @extends React.Component
 */
class StandardTexts extends Component {
  render() {
    return (
      <StandardTextsComponent />
    );
  }
}

export default StandardTexts;



// WEBPACK FOOTER //
// ./src/screens/AdvisoryApp/screens/Settings/screens/StandardTexts/index.js